import { createTranslations } from '@npco/utils-translations'

export const outstandingExpensesFieldsTranslations = createTranslations({
  categoryOptionTitle: 'Category Required',
  receiptOptionTitle: 'Receipt Required',
  noteOptionTitle: 'Note Required',
})
